import invariant from "tiny-invariant";

interface Config {
  backendUrl: string;
  baseURL: string;
  socketUrl: string;
}

// eslint-disable-next-line
// @ts-ignore
const backendUrl = import.meta.env.VITE_BACKEND_URL;
const baseURL = import.meta.env.VITE_BASE_BACKEND_URL;
const socketUrl = import.meta.env.VITE_BACKEND_SOCKET_URL;
invariant(backendUrl, "Missing BACKEND_URL in admin-dashboard");
invariant(socketUrl, "Missing SOCKET_URL in admin-dashboard");

const config: Config = {
  backendUrl,
  baseURL,
  socketUrl,
};

export default config;
